import * as cheerio from "cheerio"

export type HeadlineTag = "h1" | "h2" | "h3" | "h4"
const headlineTags: HeadlineTag[] = ["h1", "h2", "h3", "h4"]
export interface Headline {
	level: number
	text: string
}

export const removeStyleAttributes = (html: string) =>
	html.replace(/\s(?:style|color)=["'][^"']*["']/g, "")

export const addTargetBlankToLinks = (html: string) => {
	const $ = cheerio.load(html)
	$("a").each((_, link) => {
		$(link).attr("target", "_blank")
		$(link).attr("rel", "noopener noreferrer")
	})
	return $.html()
}

export const findAllHeadlines = (
	content: string | null,
	headlines: HeadlineTag[],
): Headline[] => {
	if (!content) return []
	const $ = cheerio.load(content)

	const items = $(headlines.join(",")).toArray()
	return items
		.map((hl) => {
			const tag = $(hl).get(0) as unknown as Element
			const tagName = tag.tagName.toLowerCase() as HeadlineTag
			const level = headlineTags.indexOf(tagName) + 1
			const text = $(hl).text().trim()
			return {
				level,
				text,
			}
		})
		.filter((h) => h.text.length > 0)
}
